<template>
  <div class="detail-form"
       v-loading="loading">
    <el-form :model="orginazation"
             :rules="rules"
             ref="orginazation"
             label-width="140px"
             class="org-form">
      <el-form-item label="机构名称：">{{orginazation.regulatorName}}</el-form-item>
      <el-form-item label="账号："
                    prop="adminAccount">
        <el-input disabled=""
                  v-model="orginazation.adminAccount"></el-input>
      </el-form-item>
      <el-form-item label="联系人："
                    prop="regulatorPerson">
        <el-input v-model="orginazation.regulatorPerson"></el-input>
      </el-form-item>
      <el-form-item label="手机号："
                    prop="regulatorPhone">
        <el-input v-model="orginazation.regulatorPhone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱："
                    prop="regulatorEmail">
        <el-input v-model="orginazation.regulatorEmail"></el-input>
      </el-form-item>
      <el-form-item label="网站："
                    prop="zsHomepage">
        <home-page-select v-model="orginazation.zsHomepage" />
      </el-form-item>
      <el-form-item label="监管贸易："
                    prop="tradeType">
        <el-radio-group v-model="orginazation.tradeType">
          <el-radio-button :label="1">进出口</el-radio-button>
          <el-radio-button :label="3">国内</el-radio-button>
          <el-radio-button :label="9">进出口和国内</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="创建子报检单："
                    v-if="orginazation.level === 2"
                    prop="supportSubInspectReport">
        <el-radio-group v-model="orginazation.supportSubInspectReport">
          <el-radio-button :label="1">支持</el-radio-button>
          <el-radio-button :label="0">不支持</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="企业审核："
                    v-if="orginazation.level === 2"
                    prop="supportAuditVendor">
        <el-radio-group v-model="orginazation.supportAuditVendor">
          <el-radio-button :label="1">支持</el-radio-button>
          <el-radio-button :label="0">不支持</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="进出口审核通过后显示追溯信息："
                    v-if="orginazation.level === 2"
                    prop="foreignInspectReportReviewedShowTraceInfo">
        <el-radio-group v-model="orginazation.foreignInspectReportReviewedShowTraceInfo">
          <el-radio-button :label="1">启用</el-radio-button>
          <el-radio-button :label="0">关闭</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内销审核通过后显示追溯信息："
                    v-if="orginazation.level === 2"
                    prop="inlandInspectReportReviewedShowTraceInfo">
        <el-radio-group v-model="orginazation.inlandInspectReportReviewedShowTraceInfo">
          <el-radio-button :label="1">启用</el-radio-button>
          <el-radio-button :label="0">关闭</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <staff-vendor-data-scope v-if="orginazation.level === 2"
                               :staffVendorDataScope="orginazation.staffVendorDataScope"
                               :orginazation="orginazation"
                               @fetch="callback" />
      <el-form-item label="地址："
                    prop="regulatorAddress">
        <el-input v-model="orginazation.regulatorAddress"></el-input>
      </el-form-item>
      <el-form-item label="扫码H5标题："
                    v-if="orginazation.level === 2"
                    prop="scanH5Title">
        <el-input v-model="orginazation.scanH5Title"></el-input>
      </el-form-item>
      <el-form-item label="H5第一个Tab："
                    v-if="orginazation.level === 2"
                    prop="scanH5Tab1Title">
        <el-input v-model="orginazation.scanH5Tab1Title"></el-input>
      </el-form-item>
      <el-form-item label="扫码H5底部："
                    v-if="orginazation.level === 2"
                    prop="scanH5BottomText">
        <el-input v-model="orginazation.scanH5BottomText"></el-input>
      </el-form-item>
      <el-form-item label="审批："
                    v-if="orginazation.level === 2"
                    prop="inspectReportAudit">
        <el-switch v-model="orginazation.inspectReportAudit"
                   :active-value="1"
                   :inactive-value="0"></el-switch>
      </el-form-item>
      <el-form-item label="菜单模式："
                    v-if="orginazation.hasCustomizeMenu === 1"
                    prop="menuLayout">
        <el-radio-group :value="orginazation.customizeMenu"
                        @change="configcustomizemenu">
          <el-radio-button :label="0">默认菜单</el-radio-button>
          <el-radio-button :label="1">自定义菜单</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <declaration-config-form v-if="orginazation.level === 2"
                               v-model="orginazation" />
      <el-form-item label="功能权限："
                    prop="functions">
        <checkbox-tree :treeData="orginazation.menuNodes"
                       nodeKey="funcId"
                       :defaultProps="defaultProps"
                       v-model="orginazation.functions" />
      </el-form-item>
    </el-form>
    <div style="text-align: center;">
      <el-button type="primary"
                 @click="saveOrganization">更新</el-button>
      <el-button type="primary"
                 @click="handleMenuSettings">自定义菜单</el-button>
    </div>
    <custom-menu-tree-modal ref="menu"
                            :callback="callback" />
  </div>
</template>
<script>
import CheckboxTree from '@/components/public/checkbox-tree.vue'
import HomePageSelect from '@/components/business/home-page-select.vue'
import clonedeep from 'lodash.clonedeep'
import { guid } from '@/utils/index'
import CustomMenuTreeModal from '../../../components/custom-menu-tree/custom-menu-tree-modal.vue'
import StaffVendorDataScope from './staff-vendor-data-scope.vue'
import DeclarationConfigForm from './declaration-config-form.vue'
export default {
  name: 'organization-detail',
  components: { CheckboxTree, HomePageSelect, CustomMenuTreeModal, StaffVendorDataScope, DeclarationConfigForm },
  data () {
    return {
      loading: false,
      orginazation: {
        foreignInspectReportReviewedShowTraceInfo: 0,
        inlandInspectReportReviewedShowTraceInfo: 0,
        regulatorPerson: '',
        regulatorPhone: '',
        supportSubInspectReport: 0,
        supportAuditVendor: 0,
        regulatorEmail: '',
        zsHomepage: null,
        tradeType: 1,
        inspectReportAudit: 0,
        type: [],
        menuNodes: [],
        scanH5StatementImages: [],
        scanH5StatementEntryImage: [],
        regulatorStaffs: []
      },
      defaultProps: { children: 'children', label: 'menuName' },
      rules: {
        regulatorPerson: [
          { required: true, message: '请输入机构联系人', trigger: 'blur' },
          { max: 12, message: '长度最大 12 个字符', trigger: 'blur' }
        ],
        zsHomepage: [ { required: true, message: '请选择网站登陆地址', trigger: 'change' } ],
        tradeType: [ { required: true, message: '请选择贸易类型', trigger: 'change' } ],
        regulatorPhone: [ { pattern: /^1[0-9][0-9]\d{8}$/, required: true, message: '请输入正确的手机号', trigger: 'blur' } ],
        functions: [ { type: 'array', required: true, message: '请至少选择一个功能权限', trigger: 'change' } ],
        regulatorEmail: [ { type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' } ]
      },
      current: {}
    }
  },
  methods: {
    configcustomizemenu (customizeMenu) {
      console.log(customizeMenu)
      this.$confirm(`此操作将该机构的菜单模式切换到${customizeMenu === 0 ? '自定义' : '默认'}, 是否继续?`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$$CommonApi.configcustomizemenu1({ customizeMenu: customizeMenu === 0, regulatorId: this.orginazation.regulatorId })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if (result === 0) {
                this.$message.success('设置成功')
                this.getOrganization(this.current)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              console.log(err)
            })
        })
    },
    callback () {
      this.getOrganization(this.current)
    },
    handleMenuSettings () {
      const { regulatorId: portalProfileId, regulatorName: profileName } = this.orginazation
      this.$refs.menu.init({ portalProfileId, profileName, profileType: 299 })
    },
    addOperator () {
      this.orginazation.regulatorStaffs.push({ cname: '', name: '' })
    },
    deleteOperator (row, $index) {
      this.$confirm('此操作不会立刻删除该操作员, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      })
        .then(() => {
          this.orginazation.regulatorStaffs.splice($index, 1)
        })
        .catch(() => { })
    },
    getOrganization (obj) {
      this.loading = true
      this.current = obj
      this.$store.dispatch('supervise/getregulator', {
        payload: { regulatorId: obj.regulatorId },
        success: (res) => {
          this.loading = false
          res.data.menuNodes.forEach(item => {
            if (!item.funcId) {
              item.funcId = `custom-${guid()}`
            }
          })
          const { scanH5StatementImages, scanH5StatementEntryImage } = res.data
          this.orginazation = {
            ...this.orginazation,
            ...res.data,
            functions: res.data.functions.map(item => item.funcId),
            scanH5StatementImages: this.$splitImages(scanH5StatementImages),
            scanH5StatementEntryImage: this.$splitImages(scanH5StatementEntryImage)
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    saveOrganization () {
      this.$refs.orginazation.validate(valid => {
        if (valid) {
          this.loading = true
          let organization = clonedeep(this.orginazation)
          delete organization.menuNodes
          organization.functions = organization.functions.filter(item => typeof item === 'number')
          organization.functions = organization.functions.map(item => ({ funcId: item }))
          const { scanH5StatementImages, scanH5StatementEntryImage } = organization
          this.$store.dispatch('supervise/updateregulator', {
            payload: {
              ...organization,
              scanH5StatementImages: this.$stringfyImages(scanH5StatementImages),
              scanH5StatementEntryImage: this.$stringfyImages(scanH5StatementEntryImage)
            },
            success: (res) => {
              this.loading = false
              this.getOrganization(this.current)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.org-form {
  padding: 0 30px;
}
</style>
